import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ProjectSubscriptionService} from '../../../shared/services/project-subscription/project-subscription.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../shared/services/state/states.service';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {CsvSubscription} from '../../../shared/classes/csv-subscription/csv-subscription';

@Component({
  selector: 'app-csv-sftp-subscription',
  templateUrl: './csv-sftp-subscription.component.html',
  styleUrls: ['./csv-sftp-subscription.component.css']
})
export class CsvSftpSubscriptionComponent implements OnInit {

  public faTimes = faTimes;
  public projectId: number;
  public csvSubscriptionId: number;
  public showSpinner: boolean;
  public csvSubscription: CsvSubscription;
  public csvSubscriptionForm: FormGroup;
  public projectName: string;
  public staticSubscription = true;
  public dynamicSubscription = false;
  public realTimeSubscription = false;

  constructor(private toastr: ToastrService,
              private projectSubscriptionService: ProjectSubscriptionService,
              private translate: TranslateService,
              public statesService: StatesService, private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.projectId = data.project.id;
    this.projectName = data.project.name;
    this.csvSubscriptionId = data.csvSubscriptionId;
    this.csvSubscriptionForm = new FormGroup({
        ftpServer: new FormControl(''),
        ftpPort: new FormControl(''),
        ftpUser: new FormControl(''),
        ftpPassword: new FormControl('', Validators.required),
        deleteDataAfterExport: new FormControl(false)
      },
    );

  }

  ngOnInit() {
    this.getCsvSubscription();
  }


  getCsvSubscription() {
    if (this.csvSubscriptionId !== null) {
      this.showSpinner = true;
      this.projectSubscriptionService.getCsvSubscription(this.csvSubscriptionId).subscribe(
        (csvSubscription: CsvSubscription) => {
          this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          this.csvSubscription = csvSubscription;
          this.setDataType(csvSubscription);
          this.csvSubscriptionForm.patchValue({
            ftpServer: this.csvSubscription.ftpServer !== undefined ? this.csvSubscription.ftpServer : '',
            ftpPort: this.csvSubscription.ftpPort !== undefined ? this.csvSubscription.ftpPort : '',
            ftpUser: this.csvSubscription.ftpUser !== undefined ? this.csvSubscription.ftpUser : '',
            ftpPassword: '',
            deleteDataAfterExport: this.csvSubscription.deleteDataAfterExport !== undefined ? this.csvSubscription.deleteDataAfterExport : false,

          });
          this.showSpinner = false;
        }, error => {
          this.showSpinner = false;
        });
    }
  }

  postCsvSubscription() {
    if (this.csvSubscriptionForm.valid) {
      let csvSubscription = this.buildSftpSubscription();

      if (JSON.stringify(csvSubscription) === JSON.stringify(this.csvSubscription)) {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      } else {
        this.showSpinner = true;
        this.csvSubscription = csvSubscription;
        this.projectSubscriptionService.postCsvSubscription(this.csvSubscription).subscribe(
          d => {
            this.statesService.reloadListProject.next();
            this.toastr.success(this.translate.instant('SUBSCRIPTION_CREATED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            this.matDialog.closeAll();
          },
          error => {
            this.showSpinner = false;
          });
      }
    }
  }

  getDeleteDataAfterExportText() {
    return this.csvSubscriptionForm.value.deleteDataAfterExport ? this.translate.instant('DELETE_MONGO_DATA') : this.translate.instant('KEEP_MONGO_DATA');
  }

  private buildSftpSubscription() {
    let csvSubscription = new CsvSubscription();
    csvSubscription.projectId = this.projectId;
    csvSubscription.dataType = this.getDataType();
    if (
      this.csvSubscriptionForm.value.ftpServer !== ''
      &&
      this.csvSubscriptionForm.value.ftpPort !== ''
      &&
      this.csvSubscriptionForm.value.ftpUser !== ''
      &&
      this.csvSubscriptionForm.value.ftpPassword !== ''
    ) {
      csvSubscription.ftpServer = this.csvSubscriptionForm.value.ftpServer;
      csvSubscription.ftpPort = this.csvSubscriptionForm.value.ftpPort;
      csvSubscription.ftpUser = this.csvSubscriptionForm.value.ftpUser;
      csvSubscription.ftpPassword = this.csvSubscriptionForm.value.ftpPassword;
    } else {
      delete csvSubscription.ftpServer;
      delete csvSubscription.ftpPort;
      delete csvSubscription.ftpUser;
      delete csvSubscription.ftpPassword;
    }
    csvSubscription.deleteDataAfterExport = this.csvSubscriptionForm.value.deleteDataAfterExport;
    return csvSubscription;

  }

  private getDataType() {
    let dataArray = [];
    if (this.staticSubscription) {
      dataArray.push('sta');
    }
    if (this.dynamicSubscription) {
      dataArray.push('dyn');
    }
    if (this.realTimeSubscription) {
      dataArray.push('real_time');
    }
    return dataArray;
  }

  private setDataType(csvSubscription: CsvSubscription) {
    let dataType = csvSubscription.dataType !== undefined ? csvSubscription.dataType : [];
    this.staticSubscription = dataType.includes('sta');
    this.dynamicSubscription = dataType.includes('dyn');
    this.realTimeSubscription = dataType.includes('real_time');
  }
}
